import "../../../chunks/async.js";
import { e as ensure_array_like, j as await_block, b as escape_html, a as attr } from "../../../chunks/renderer.js";
import "../../../chunks/servers.remote.js";
import "@sveltejs/kit/internal";
import "../../../chunks/url.js";
import "../../../chunks/utils.js";
import { r as resolve } from "../../../chunks/server2.js";
import "../../../chunks/exports.js";
import "../../../chunks/state.svelte.js";
import { P as Panel } from "../../../chunks/Panel.js";
import { T as TooltipTable } from "../../../chunks/TooltipTable.js";
import { s as serverName, f as formatBytes } from "../../../chunks/filters.js";
import { S as SvelteSet } from "../../../chunks/index-server.js";
function _page($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let { data } = $$props;
    const retryingServers = new SvelteSet();
    {
      let actions = function($$renderer3) {
        $$renderer3.push(`<button class="btn btn-default btn-sm">${escape_html("Add Server")}</button> `);
        {
          $$renderer3.push("<!--[-1-->");
        }
        $$renderer3.push(`<!--]-->`);
      };
      Panel($$renderer2, {
        title: "Servers",
        actions,
        children: ($$renderer3) => {
          $$renderer3.push(`<table class="table"><thead><tr><th>Name</th><th>Databases</th><th>Size</th><th></th></tr></thead><tbody>`);
          if (data.servers && data.servers.length > 0) {
            $$renderer3.push("<!--[0-->");
            $$renderer3.push(`<!--[-->`);
            const each_array = ensure_array_like(data.servers);
            for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
              let server = each_array[$$index];
              $$renderer3.push(`<tr class="group"><td>`);
              await_block(
                $$renderer3,
                server.details,
                () => {
                  $$renderer3.push(`<span>${escape_html(serverName(server.name))}</span>`);
                },
                (details) => {
                  if ("error" in details && details.error) {
                    $$renderer3.push("<!--[0-->");
                    $$renderer3.push(`<span class="error"><span class="badge badge-danger"${attr("title", details.error.message)}>Error</span> ${escape_html(serverName(server.name))}</span>`);
                  } else {
                    $$renderer3.push("<!--[-1-->");
                    $$renderer3.push(`<a${attr("href", resolve(`/servers/${encodeURIComponent(server.name)}/databases`))}>${escape_html(serverName(server.name))}</a>`);
                  }
                  $$renderer3.push(`<!--]-->`);
                }
              );
              $$renderer3.push(`<!--]--></td><td>`);
              await_block(
                $$renderer3,
                server.details,
                () => {
                  $$renderer3.push(`<span style="color: var(--text-secondary);">...</span>`);
                },
                (details) => {
                  if ("databases" in details && details.databases) {
                    $$renderer3.push("<!--[0-->");
                    TooltipTable($$renderer3, {
                      columns: [
                        { header: "Database", key: "name" },
                        { header: "Size", key: "size" }
                      ],
                      rows: details.databases.map((db) => ({ name: db.name, size: formatBytes(db.size) })),
                      children: ($$renderer4) => {
                        $$renderer4.push(`<!---->${escape_html(details.databases.length)}`);
                      }
                    });
                  } else {
                    $$renderer3.push("<!--[-1-->");
                  }
                  $$renderer3.push(`<!--]-->`);
                }
              );
              $$renderer3.push(`<!--]--></td><td>`);
              await_block(
                $$renderer3,
                server.details,
                () => {
                  $$renderer3.push(`<span style="color: var(--text-secondary);">...</span>`);
                },
                (details) => {
                  if ("size" in details && details.size !== void 0) {
                    $$renderer3.push("<!--[0-->");
                    $$renderer3.push(`${escape_html(formatBytes(details.size))}`);
                  } else {
                    $$renderer3.push("<!--[-1-->");
                  }
                  $$renderer3.push(`<!--]-->`);
                }
              );
              $$renderer3.push(`<!--]--></td><td style="width: 250px"><div class="flex gap-2 justify-end">`);
              await_block($$renderer3, server.details, () => {
              }, (details) => {
                if ("error" in details && details.error) {
                  $$renderer3.push("<!--[0-->");
                  $$renderer3.push(`<button class="btn btn-default btn-sm -my-2 hidden group-hover:inline"${attr("disabled", retryingServers.has(server._id), true)}>${escape_html(retryingServers.has(server._id) ? "Retrying..." : "Retry")}</button>`);
                } else {
                  $$renderer3.push("<!--[-1-->");
                }
                $$renderer3.push(`<!--]-->`);
              });
              $$renderer3.push(`<!--]--> <button class="btn btn-outline-danger btn-sm -my-2 hidden group-hover:inline">Remove from list</button></div></td></tr>`);
            }
            $$renderer3.push(`<!--]-->`);
          } else {
            $$renderer3.push("<!--[-1-->");
            $$renderer3.push(`<tr><td colspan="4"><div class="text-center">No servers...</div></td></tr>`);
          }
          $$renderer3.push(`<!--]--></tbody></table>`);
        },
        $$slots: { actions: true, default: true }
      });
    }
    $$renderer2.push(`<!----> `);
    {
      $$renderer2.push("<!--[-1-->");
    }
    $$renderer2.push(`<!--]-->`);
  });
}
export {
  _page as default
};
